(function ($) {
 "use strict";
  jQuery(document).ready(function(){
    
		//---------------------------------------------
		//Nivo slider
		//---------------------------------------------
			$('#ensign-nivoslider-3').nivoSlider({
				effect: 'random',
				slices: 15,
				boxCols: 8,
				boxRows: 4,
				animSpeed: 500,
				pauseTime: 5000,
				startSlide: 0,
				directionNav: true,
				controlNavThumbs: false,
				pauseOnHover: true,
				manualAdvance: false
			 }); 
  });
})(jQuery); 